"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const scheduleSlice_1 = require("../../features/schedules/scheduleSlice");
const button_1 = __importDefault(require("../button/button"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const utils_1 = require("../../utils/utils");
const eventConstants_1 = require("../../constants/eventConstants");
const analytics_1 = require("../../utils/analytics");
const FieldErrorMessageComponent_1 = __importDefault(require("../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const typesConstants_1 = require("../../constants/typesConstants");
const spinner_1 = __importDefault(require("../spinner/spinner"));
const CallLaterComponent = ({ schedule }) => {
    const dispatch = useAppDispatch_1.default();
    const { officer, callLaterStatus, loadingStatus } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
        callLaterStatus: state.schedule.callLaterStatus,
        loadingStatus: state.notifications.loadingStatus,
    }));
    const [timePickerVisible, setTimePickerVisible] = react_1.useState(false);
    const [errorMessage, setErrorMessage] = react_1.useState('');
    const [availabeRescheduleTimes, setAvailableRescheduleTimes] = react_1.useState([]);
    const today = new Date();
    const callLaterIsPending = callLaterStatus.status === typesConstants_1.PENDING_STATUS || loadingStatus === typesConstants_1.PENDING_STATUS;
    const handleCallLaterPress = () => {
        setTimePickerVisible(!timePickerVisible);
    };
    const confirmRescheduleTime = (time) => {
        const [hours, minutes] = time.split(':').map((e) => Number(e));
        const datetime = new Date(new Date().setHours(hours, minutes));
        const currentTime = new Date();
        // Move time forward by 11 minutes (to account for differences in seconds)
        currentTime.setMinutes(today.getMinutes() + 11);
        // If selected time is less than 10 minutes from now, show error
        if (datetime < currentTime) {
            setErrorMessage('The selected time is in the past.');
            return;
        }
        setTimePickerVisible(false);
        analytics_1.logEvent(eventConstants_1.CONFIRM_CALL_LATER);
        // The datetime is converted to ISO string (in UTC timezone) before being sent
        dispatch(scheduleSlice_1.rescheduleSchedule({ scheduleId: schedule.id, rescheduleDateTime: datetime }));
    };
    react_1.useEffect(() => {
        if (callLaterStatus.status === typesConstants_1.SUCCEEDED_STATUS) {
            dispatch(scheduleSlice_1.resetScheduleState()); // Reset schedule state before trying to get a new schedule
            if (officer.scheduling_type === typesConstants_1.SCHEDULING_TYPE_MANUAL) {
                dispatch(scheduleSlice_1.getNextSchedule());
            }
        }
        else if (callLaterStatus.status === typesConstants_1.FAILED_STATUS) {
            setErrorMessage(utils_1.getError('non_field_errors', callLaterStatus.errors) || 'An error occurred. Please try again.');
        }
        setTimePickerVisible(false);
    }, [callLaterStatus.status]);
    const getAvailableRescheduleTimes = () => {
        // This function generates time slots for reschedule starting from the factor of 15 closest to the current time to 17:45 (the last before 6PM)
        // Example: if current time is 11:18, it would return 11:30, 11:45...
        let currentHour = today.getHours();
        let currentMinute = today.getMinutes();
        const remainder = currentMinute % 15;
        // Change to next highest factor of 15
        currentMinute = remainder === 0 ? currentMinute + 15 : currentMinute - remainder + 15;
        // If next highest factor of 15 is 60 (or more), change to 0 and increase hour
        if (currentMinute >= 60) {
            currentMinute = 0;
            currentHour += 1;
        }
        const availableTimes = [];
        const endHour = 18; // Should stop before 6PM
        for (let index = currentHour; index < endHour; index += 1) {
            for (let j = currentMinute; j < 60; j += 15) {
                availableTimes.push(`${index}:${j.toString().padStart(2, '0')}`);
                if (j + 15 >= 60) {
                    currentMinute = 0;
                }
            }
        }
        return availableTimes;
    };
    // Change whenever the time picker visibility changes
    react_1.useEffect(() => {
        setAvailableRescheduleTimes(getAvailableRescheduleTimes());
    }, [timePickerVisible]);
    const anchor = (react_1.default.createElement(button_1.default, { icon: free_solid_svg_icons_1.faPhoneSlash, text: "Call later", onPress: handleCallLaterPress, eventName: eventConstants_1.CALL_LATER_BUTTON }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_paper_1.Menu, { visible: timePickerVisible, onDismiss: () => setTimePickerVisible(false), anchor: anchor }, availabeRescheduleTimes.map((time) => (react_1.default.createElement(react_native_paper_1.Menu.Item, { disabled: callLaterIsPending, title: time, onPress: () => confirmRescheduleTime(time), key: time })))),
        callLaterIsPending && react_1.default.createElement(spinner_1.default, null),
        !!errorMessage && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginLeftTen },
            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: errorMessage })))));
};
exports.default = CallLaterComponent;
